import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=cc3ebbcc&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3ebbcc",
  null
  
)

export default component.exports